import { __awaiter, __generator } from "tslib";
import { useCallback, useMemo, useRef } from 'react';
import { addToTrie } from '../addToTrie';
import { deleteTrie } from '../deleteTrie';
import { getWorker } from '../getWorker';
import { queryTrie } from '../queryTrie';
export function useEdgeworthTrie() {
    var _this = this;
    var indexedItemIdsSetRef = useRef(new Set());
    var workerRef = useRef();
    var queryCountRef = useRef(0);
    var getWorkerPromise = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!workerRef.current) return [3 /*break*/, 2];
                    _a = workerRef;
                    return [4 /*yield*/, getWorker()];
                case 1:
                    _a.current = _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/, workerRef.current];
            }
        });
    }); }, []);
    return useMemo(function () { return ({
        addToTrie: function (items, onIndexChanged) { return __awaiter(_this, void 0, void 0, function () {
            var itemsAdded, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = addToTrie;
                        return [4 /*yield*/, getWorkerPromise()];
                    case 1: return [4 /*yield*/, _a.apply(void 0, [_b.sent(), indexedItemIdsSetRef.current,
                            items,
                            onIndexChanged])];
                    case 2:
                        itemsAdded = _b.sent();
                        itemsAdded.forEach(function (itemAdded) {
                            return indexedItemIdsSetRef.current.add(itemAdded.id);
                        });
                        return [2 /*return*/, itemsAdded];
                }
            });
        }); },
        queryTrie: function (documents, text) { return __awaiter(_this, void 0, void 0, function () {
            var currentQueryCount, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        currentQueryCount = queryCountRef.current++;
                        _a = queryTrie;
                        return [4 /*yield*/, getWorkerPromise()];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent(), currentQueryCount,
                            documents,
                            text])];
                }
            });
        }); },
        deleteTrie: function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        indexedItemIdsSetRef.current.clear();
                        queryCountRef.current = 0;
                        _a = deleteTrie;
                        return [4 /*yield*/, getWorkerPromise()];
                    case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
                }
            });
        }); },
    }); }, [getWorkerPromise]);
}
//# sourceMappingURL=useEdgeworthTrie.js.map